import * as angular from "angular";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Limit } from "../../models/limit.model";
import { DialogUtils } from "../../helper/dialog.helper";

let AskForPurchaseComponent = {
    selector: "askForPurchase",
    templateUrl: "/angular/components/product/ask-for-purchase.component.html",
    bindings: {
        quantity: "=?",
    },
    controller: class AskForPurchase {
        // * bindings for typescript compiler *
        public quantity?: any;
        // ************************************

        private superUsersAvailable: number;
        private dialog: DialogUtils;

        constructor(
            LimitDataProvider: LimitDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.dialog = DialogUtils;
            LimitDataProvider.get().then(
                (limits: Limit) =>
                    (this.superUsersAvailable =
                        (limits.superusers ?? 0) +
                        (limits.extrasuperusers ?? 0))
            );
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("product", [])
    .component(AskForPurchaseComponent.selector, AskForPurchaseComponent);
